var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row overflow-hidden"},_vm._l((5),function(index){return _c('aha-skeleton-loader',{key:index,staticClass:"template-thumbnail flex-shrink-0 mr-8",attrs:{"width":"250px","height":"210px"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }